import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
export const Testimonials = () => {
  const testimonials = [{
    name: 'Tomás R.',
    position: 'Centro, 22 años',
    location: 'Córdoba',
    text: 'Siempre fui fuerte en el gimnasio pero en la cancha me sentía pesado. Con el módulo de potencia y el bono de velocidad cambié mi forma de correr. Ahora rompo la línea de ventaja mucho más fácil.'
  }, {
    name: 'Facundo M.',
    position: 'Medioscrum, 24 años',
    location: 'Buenos Aires',
    text: 'El capítulo de control del partido me abrió la cabeza. Entendí cómo leer los espacios y manejar los tiempos. Además, las rutinas físicas me ayudaron a estar más explosivo en la base del ruck.'
  }, {
    name: 'Ignacio L.',
    position: 'Pilar, 26 años',
    location: 'Rosario',
    text: 'Estaba estancado con mi empuje en el scrum. Apliqué los conceptos de fuerza funcional y posicionamiento del Tomo 5 y la diferencia es abismal. Muy recomendado para primeras líneas.'
  }, {
    name: 'Bautista G.',
    position: 'Wing, 20 años',
    location: 'Tucumán',
    text: 'Los drills de velocidad del bono son una locura. Bajé mis tiempos en los 10 y 30 metros. Ahora me siento con mucha más confianza para encarar el 1 vs 1 por afuera.'
  }, {
    name: 'Santiago P.',
    position: 'Tercera Línea, 25 años',
    location: 'Mendoza',
    text: 'Lo que más me sirvió fue la parte de mentalidad y prevención de lesiones. Venía de dos desgarros seguidos y con los protocolos del manual pude volver a jugar sin miedo y al 100%.'
  }];
  return <section className="w-full py-20 px-4 bg-zinc-900 border-t border-zinc-800" data-id="element-202">
      <div className="max-w-6xl mx-auto" data-id="element-203">
        <div className="text-center mb-16" data-id="element-204">
          <h2 className="text-3xl md:text-5xl font-bold uppercase tracking-tight mb-6 font-oswald text-white" data-id="element-205">
            JUGADORES QUE YA{' '}
            <span className="text-lime-400" data-id="element-206">SUBIERON SU NIVEL</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-207">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-zinc-950 p-6 rounded-2xl border border-zinc-800 flex flex-col" data-id="element-208">
              <div className="flex gap-1 mb-4" data-id="element-209">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-lime-500 text-lime-500" data-id="element-210" />)}
              </div>
              <p className="text-zinc-300 mb-6 flex-grow italic" data-id="element-211">
                "{test.text}"
              </p>
              <div className="mt-auto border-t border-zinc-800 pt-4" data-id="element-212">
                <p className="font-bold text-white font-oswald tracking-wide" data-id="element-213">
                  {test.name}
                </p>
                <p className="text-sm text-lime-400" data-id="element-214">
                  {test.position} | {test.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};